import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import 'rxjs/add/operator/debounceTime';
import { AuthService } from "../../auth.service";
import { AppCommonService } from "../../appcommon.service";
import { GlobalService } from "../../global.service";
import { Contact } from "./contact";
import { HeaderAndNavigationService } from "../headerandnavigation.service";
import { LoaderService } from "../../LoaderService";
declare var $: any;


@Component({
  selector: '[mft-contact]',
  templateUrl: './contact.component.html'
})
export class ContactComponent {
  contactForm: FormGroup;
  contact: Contact = new Contact();
  errorMessage: string;
  public loading = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private appCommonService: AppCommonService,
    private router: Router,
    public globalService: GlobalService,
    public headerAndNavigationService: HeaderAndNavigationService,
    public loaderService: LoaderService,

  ) { }

  ngOnInit(): void {

    this.contactForm = this.fb.group({
      FullName: ['', [Validators.required]],
      CompanyName: ['', [Validators.required]],
      Email: ['', [Validators.required]],
      Telephone: ['', [Validators.required]],
      Postcode: ['', [Validators.required]],
      //EnquiryDetail: ['', [Validators.required]],
      EnquiryDetail: '',
      DecisionMaker: ['', [Validators.required]],
      FuelCardHolder: ['', [Validators.required]],
      ContactingFor: ['', [Validators.required]]
    });
  }

  OnContact(): void {
    if (this.contactForm.dirty && this.contactForm.valid) {
      // Copy the form values over the product object values
      let p = Object.assign({}, this.contact, this.contactForm.value);
      this.loaderService.display(true);
      this.headerAndNavigationService.callContact(p)
        .subscribe(
          () => {
            this.globalService.showSuccess("Contact", "information submitted successfully.");
            this.onContactComplete();
            this.loaderService.display(false);
          },
          (error: any) => {
            this.loaderService.display(false);
            this.globalService.showError("Contact", <any>error)
          }
        );
    } else if (!this.contactForm.dirty) {
      this.onContactComplete();
    }
  }

  onContactComplete(): void {
    // Reset the form to clear the flags
    this.contactForm.reset();
    this.errorMessage = '';
  }
}



// WEBPACK FOOTER //
// ./src/app/headerandnavigation/contact/contact.component.ts